import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 590,
	height: 834,
	fill: "none",
	viewBox: "0 0 590 834",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#D66313",
			d: "M355.3 442C395.7 572.1 537 765.7 537 765.7v45.8h-53.7S356.4 616.3 326.2 486a14032 14032 0 0 1-58.4-271l7.4-13 9.5 7.4s42.9 143.3 70.6 232.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BC4D00",
			d: "M356.2 445.9c39.5 126.3 180.9 319.7 180.9 319.7V812l-22.7-46.4S386.5 619 353 492c-26.8-102-68.2-272-68.2-272l-4.8-6.6 8.3 6.6s40.8 139.3 68 226Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M.2 390.7S124 117.4 246.4 186.2c30.7 17.3 29.2 39.6 29.2 39.6s-66.3-3.3-127 48l-18.5-9.1 5.8 19.8C124.2 294 111.2 304.6 98 315l-18.2-11 9 18.5-17.8 14L55.4 325l6.6 18.4C28.1 369.7.2 390.7.2 390.7Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint1_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M52.6 110.5s151.6-37 234 72.3c4 5.4-22.4 26.6-22.4 26.6s-42.4-35-75.3-52.9a222 222 0 0 0-14-6.8l5.9-16.9-11.7 14.3a361 361 0 0 0-4-1.7l4.3-12.6-8.8 10.8c-10-4-20.6-7.8-31-11.3l1.1-14.6-13.6 10.6a991.9 991.9 0 0 0-64.5-17.8Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint2_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M393 0S253 68.6 259.6 205.1c.3 6.9 34.2 6.2 34.2 6.2s10.2-54 24-88.8l3.2-7.4-11.7-9 17.6-3.2c6.7-13.2 14.9-27 23.2-40.3l-6.3-5 7.8 2.6 3.2-5-11-9 13.8 4.7C376 22.5 393.1 0 393.1 0Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint3_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M117.4 487.3S91.5 285 245.4 194c7.7-4.5 31.3 33 31.3 33s-12.1 11.7-27.8 28.3l-26.7-5.7 10.5 23.3a590.3 590.3 0 0 0-25 29.8l-14.7-5.4 8.7 13.3-4.7 6.5-.3.5-18.7-11.1 15.1 16.4c-7.6 11.6-15.1 25-22.4 39.3l-15.5 2.3 9.5 9.7c-6.2 12.8-12.2 26-17.6 38.5l-8 1.2 5.2 5.2c-16 37.5-27 68.3-27 68.3Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint4_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M308.3 171.1C418.7 127 482 454.7 482 454.7S459.8 421 432.7 382l7.5-7.6-14.4-2.2a2066 2066 0 0 0-29.6-40.9l12.8-14-16 9.7-6-8 7.1-10.7-12 4.4a263 263 0 0 0-26.6-31l8.1-15-14.6 8.8C312.5 241 274.9 223 274.9 223s.6-38.7 33.4-51.9Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint5_linear_15977_3057)",
			fillRule: "evenodd",
			d: "M284.4 158.5C408 43 589.5 283.5 589.5 283.5s-34.6-17-76.8-34.4l5.7-18.5-11 16.4-8.4-3.4 2-14.9-11 11.3c-11.9-4.6-23.9-9-35.6-13l1.4-22.9-13 19.2a396.2 396.2 0 0 0-41.4-10.7l1-17.2-10.4 15.3c-82-15-107.6 6-107.6 6s-25.8-34.1 0-58.2Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_15977_3057",
				x1: 185,
				x2: 22.9,
				y1: 164.2,
				y2: 366.8,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_15977_3057",
				x1: 272.4,
				x2: 78,
				y1: 129.4,
				y2: 106.4,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_15977_3057",
				x1: 236.3,
				x2: 370.9,
				y1: 155.1,
				y2: 13.1,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_15977_3057",
				x1: 174,
				x2: 115.7,
				y1: 204.6,
				y2: 453.7,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_15977_3057",
				x1: 378.5,
				x2: 479.6,
				y1: 167,
				y2: 418.8,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_15977_3057",
				x1: 328.6,
				x2: 572.6,
				y1: 121,
				y2: 240.2,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C9463" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#56BA82"
				})]
			})
		] })
	]
});
export default SvgPalm;
